import { useEffect, useRef, useState } from "react";
import { Alert, AlertTitle, Button, Typography, Grid } from '@mui/material';
import { ExpansiblePanelPI } from "../Common/ExpansiblePanel";
import { UnauthorizedPage } from "../../pages/Error/ErrorUnauthorized";
import UsuarioService from "../../services/UsuarioService";
import { RolesInvUnidadDTO } from "../../interfaces/Usuarios/RolPersonaUnidadDTO";
import { CargoDecanoEspolDTO } from "../../interfaces/Usuarios/CargoDecanoEspolDTO";
import { useCasUserContext } from "../../services/casUserContext";

interface Props{
    roles: Array<RolesInvUnidadDTO>,
    usuario: string,
    nombres: string;
    apellidos: string;
    autorizado: boolean;
    decano: Array<CargoDecanoEspolDTO>;
}

const usuarioService = new UsuarioService();

const listCoordinadores = ['mdpilay@espol.edu.ec','jvielma@espol.edu.ec','carmpadi@espol.edu.ec','marymont@espol.edu.ec','mijedari@espol.edu.ec','wavelasq@espol.edu.ec','pcornejo@espol.edu.ec','cjtutive@espol.edu.ec','pjochoa@espol.edu.ec'];
const listDecanos = ['nsolorza@espol.edu.ec','edelgado@espol.edu.ec','meromero@espol.edu.ec','mjimenez@espol.edu.ec','pcarrion@espol.edu.ec','jaragund@espol.edu.ec','achanaba@espol.edu.ec','rvsalaza@espol.edu.ec','mgranda@espol.edu.ec'];
const directoresCentros = ['ldomingu@espol.edu.ec','ssonnen@espol.edu.ec','gsorian@espol.edu.ec','jmceva@espol.edu.ec','bvintimi@espol.edu.ec','vhuguaro@espol.edu.ec','fmorante@espol.edu.ec','pcornejo@espol.edu.ec','dochoa@espol.edu.ec'];

export default function WebComp(props:Props){
    const casUserContext = useCasUserContext();
    const correo = casUserContext.userData.emailAddress;
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const idAuth = "ReportSection6df9d13520be11bd6aeb";
    const idInv = "ReportSection6217f10af82242c35fb0";
    const autoAuth="true";
    let enlaceAutoridad = 'https://app.powerbi.com/groups/309eb7b4-c7c8-452f-a470-d5038d533d78/reports/865604e5-6bb8-4b03-a6cf-9640d60747f7/'+idAuth;
    let enlaceByUnidad = 'https://app.powerbi.com/reportEmbed?reportId=c71f4933-435e-44ac-84c6-662c960b6c47&autoAuth=true&ctid=b7af8caf-83d8-4644-85ae-317c545223c1';
    let enlaceDirectorCentro = 'https://app.powerbi.com/reportEmbed?reportId=93357b9a-7265-4e36-a735-bc6d1b243d4e&autoAuth=true&ctid=b7af8caf-83d8-4644-85ae-317c545223c1';
    let enlaceInvestigador= 'https://app.powerbi.com/groups/309eb7b4-c7c8-452f-a470-d5038d533d78/reports/865604e5-6bb8-4b03-a6cf-9640d60747f7/'+idInv+'?filter=HIST_consolidado%2FUSER%20eq%20%27'+props.usuario+'%27';
    let enlaceAutoridadIframe = 'https://app.powerbi.com/reportEmbed?reportId=865604e5-6bb8-4b03-a6cf-9640d60747f7&autoAuth='+autoAuth+'&filterPanelEnabled=False&pageName='+idAuth;
    let enlaceByUnidadIframe = 'https://app.powerbi.com/reportEmbed?reportId=c71f4933-435e-44ac-84c6-662c960b6c47&autoAuth=true&ctid=b7af8caf-83d8-4644-85ae-317c545223c1';
    let enlaceDirectorCentroIframe = 'https://app.powerbi.com/reportEmbed?reportId=93357b9a-7265-4e36-a735-bc6d1b243d4e&autoAuth=true&ctid=b7af8caf-83d8-4644-85ae-317c545223c1';
    let enlaceInvestigadorIframe = 'https://app.powerbi.com/reportEmbed?reportId=865604e5-6bb8-4b03-a6cf-9640d60747f7&autoAuth='+autoAuth+'&filterPanelEnabled=False&pageName='+idInv+'&filter=HIST_consolidado%2FUSER%20eq%20%27'+props.usuario+'%27';
    let enlaceDummy = 'https://app.powerbi.com/reportEmbed?reportId=c71f4933-435e-44ac-84c6-662c960b6c47&autoAuth=true&ctid=b7af8caf-83d8-4644-85ae-317c545223c1';
    let [link,setLink] = useState('');
    let [linkIf,setLinkIf] = useState('');

    const openLinkInNewTab = (link:string) => {
        const url = link; // Reemplaza esto con tu URL deseada
        window.open(url, '_blank');
    };

    function getRoles(roles:Array<RolesInvUnidadDTO>,decano: Array<CargoDecanoEspolDTO>):string{
        let rol = "";
        //console.log(roles);
        if(usuarioService.authorizedByRol(145,roles) || usuarioService.authorizedByRol(150,roles) || usuarioService.authorizedByRol(143,roles) || usuarioService.authorizedByRol(142,roles) || usuarioService.authorizedByRol(151,roles)){
            rol = "AUTORIDAD"
        }else if(listDecanos.includes(correo)){
            rol = "DECANO"
        }else if(directoresCentros.includes(correo)){
            rol = "DIRCENTRO"
        }else if(usuarioService.authorizedByRol(143,roles)){
            rol = "ADMINUNIDAD"
        }else if(listCoordinadores.includes(correo)){
            rol = "COORDINADOR"
        }else if(usuarioService.authorizedByRol(147,roles)){
            rol = "CONSULTOR"
        }else{
            rol = "INVESTIGADOR"
        }
        console.log(rol)
        return rol;
    }

    function miEnlace(rol:string){
        switch(rol){
            case "AUTORIDAD":
                setLink(enlaceAutoridad);
                setLinkIf(enlaceAutoridadIframe);
                break;
            case "DECANO":
                setLink(enlaceByUnidad);
                setLinkIf(enlaceByUnidadIframe);
                break;
            case "DIRCENTRO":
                setLink(enlaceDirectorCentro);
                setLinkIf(enlaceDirectorCentroIframe);
                break;
            // case "CONSULTOR":
            //     const consultor = props.roles.find(x => x.idrol === 147);
            //     setLink(enlaceByUnidad+consultor?.idunidad);
            //     setLinkIf(enlaceByUnidadIframe+consultor?.idunidad);
            //     break;
            case "ADMINUNIDAD":
                const adminUnidad = props.roles.find(x => x.idrol === 143);
                setLink(enlaceByUnidad+adminUnidad?.idunidad);
                setLinkIf(enlaceByUnidadIframe+adminUnidad?.idunidad);
                break;
            case "COORDINADOR":
                setLink(enlaceByUnidad);
                setLinkIf(enlaceByUnidadIframe);
                break;
            default:
                setLink(enlaceDummy);
                setLinkIf(enlaceDummy);
                break;
        }
    }

    useEffect(() => {
        let rol = getRoles(props.roles,props.decano);
        miEnlace(rol);
        //console.log(rol)
        //console.log(props.autorizado)
    },[props.autorizado]);
    
    return(
        <>
        {props.autorizado && (
            props.autorizado ?
            <>
            <Typography variant="h5" gutterBottom>
            <Grid container spacing={2}>
                <Grid item xs={10} sm={10} md={10} lg={10}>
                    Periodo de Evaluación
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2}>
                </Grid>         
            </Grid>
            </Typography>
            {/* <ExpansiblePanelPI title="Antes de iniciar sesión" nombres={props.nombres} apellidos={props.apellidos} usuario={props.usuario} /> */}
            <Grid container spacing={2} sx={{p:1}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <iframe
                    ref={iframeRef} 
                    title='ReporteHistoriaEvaluaciones' 
                    style={{ width: '100%', height: '700px', border: 'none' }} 
                    src={linkIf}>
                    </iframe>
                </Grid>
            </Grid>
            </>
            :
            <UnauthorizedPage />)
        }
        {!props.autorizado && (
            <UnauthorizedPage />)
        }
        </>
    );
}